module.exports = __webpack_public_path__ + "static/media/darhamad.9e8e50cb.webp";